import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ChevronRight } from 'lucide-react'

export const C1BreadcrumbsTheme: Components<Theme>['MuiBreadcrumbs'] = {
    defaultProps: {
        separator: <C1Icon icon={ChevronRight} />,
        'aria-label': 'breadcrumb',
    },
    styleOverrides: {
        separator: ({ theme }) =>
            theme.unstable_sx({
                color: 'text.primary',
                marginLeft: 1,
                marginRight: 1,
            }),
    },
}
